import i18n from "../../utilities/i18n";

const PrintListHeadData = [
    {
        "name": "Printer Name",
        "type": "string",
        "width": "medium",
        "sort": false,
    },
    {
        "name": "Target Printer",
        "type": "date",
        "width": "medium",
        "sort": false,
    },
    {
        "name": "Remarks",
        "type": "date",
        "width": "medium",
        "sort": false,
    },
    {
        "name": i18n.t("dictionariesPages.action"),
        "type": "button",
        "width": "action_column",
        "sort": false,
        "align":"center"
    },
];

export const PrintListTableBodyData = [
    [
        {
            "id": "",
            "name": "name",
            "value": "",
            "type": "string",
            "align": "left",
            "width": "medium",
        },
        {
            "id": "",
            "name": "is_target_printer",
            "value": "",
            "type": "string",
            "align": "left",
            "width": "medium",
        },
        {
            "id": "",
            "name": "remarks",
            "value": "",
            "type": "string",
            "align": "left",
            "width": "medium",
        },
        {
            "id": "",
            "name": "action",
            "type": "button",
            "align": "center",
            "width": "action_column",
            "dropdown": [
                { "name": "Edit" },
                { "name": "Delete" },
            ],
        },
    ],
];


export const printListTableData = {
    "name": "simpleTable",
    "isResize": true,
    "isFixedHead": true,
    "tableHeadings": PrintListHeadData,
    "tableBodyData": PrintListTableBodyData,
};
